import * as React from "react";
import { InputProps } from "../../types/InputProps";

import TextField from "@material-ui/core/TextField";
import { InputAdornment } from "@material-ui/core";

class InputText extends React.Component<InputProps> {

    public render() {
        return (
            <TextField
                disabled={this.props.disabled}
                type="text"
                style={{ width: "100%" }}
                label={this.props.label ? this.props.label : null}
                placeholder={this.props.placeholder ? this.props.placeholder : null}
                value={this.props.value ? this.props.value : ""}
                error={this.props.error ? this.props.error : false}
                helperText={this.props.legend ? this.props.legend : ""}
                onChange={(event) => this.props.onChange(event.target.value, event.target)}
                required={this.props.required}
                inputProps={{
                    maxLength: this.props.maxLength ? this.props.maxLength : null
                }}
                InputProps={{
                    endAdornment: this.props.description ? <InputAdornment position="end">{this.props.description}</InputAdornment> : null                
                }}
            />
        );
    }

}

export default InputText;


// WEBPACK FOOTER //
// ./src/components/InputText/InputText.tsx